import { validatePassportAndNRIC } from "utils/nric";
import { validateMobile } from "utils/validateMobile";

export const CURRENT_YEAR = new Date().getFullYear();

export const YEAR = () => {
  const ages = [];
  const subtractedYear = CURRENT_YEAR - 120;
  // Current year - 16 to 120 year old in desc
  for (let x = CURRENT_YEAR - 16; x >= subtractedYear; x--) {
    ages.push({ id: x, text: x });
  }

  return ages;
};

export const LANGUAGES = [
  { id: "EN", language: "English" },
  { id: "CN", language: "Chinese" },
  { id: "MA", language: "Malay" },
  { id: "TA", language: "Tamil" }
];

export const ID_TYPE = {
  Passport : "PP",
  CPFAccountNumber: "CA"
}


const NRIC_INDEX = 0;
const AGE_INDEX = 1;
const LANGUAGE_INDEX = 2;
const FURTHER_ENQUIRE_INDEX = 3;
const MOBILE_INDEX = 4;
const OTHER_MAIN_SERVICE_INDEX = 5;

const FURTHER_ENQUIRES_HAVE = "1";

export const INDEX = {
  NRIC_INDEX,
  AGE_INDEX,
  LANGUAGE_INDEX,
  FURTHER_ENQUIRE_INDEX,
  MOBILE_INDEX,
  OTHER_MAIN_SERVICE_INDEX
};

export const ValidateData = (age, language, isCrps) => {
  const validateError = [];
  if (!isCrps && !age) {
    validateError[AGE_INDEX] = "Birth year is required.";
  }
  if (!language) {
    validateError[LANGUAGE_INDEX] = "Cannot Empty.";
  }
  return validateError;
};

export const ValidateMobileData = (mobile) => {
  const validateError = [];
  if (!mobile) {
    validateError[MOBILE_INDEX] = "Mobile Number is required.";
  }
  if (mobile && !validateMobile(mobile)) {
    validateError[MOBILE_INDEX] =
      "Please enter a valid 8-digit Singapore mobile number starting with 8 or 9.";
  }

  return validateError;
};

export const ValidateNRICData = (anotherNRIC, nric) => {
  const validateError = [];
  if (!anotherNRIC) {
    validateError[NRIC_INDEX] =
      "Please enter a valid NRIC / FIN / Passport number";
  }
  if (anotherNRIC && !validatePassportAndNRIC(anotherNRIC)) {
    validateError[NRIC_INDEX] = "Invalid NRIC / FIN / Passport number";
  }
  if (anotherNRIC === nric) {
    validateError[NRIC_INDEX] =
      "Another person NRIC / FIN / Passport number can not be same as main visitor.";
  }

  return validateError;
};

